import { setLocale, splitLocalePrefix } from './locale';

/**
 * A language-prefixed URL opened in the SPA (`/es/faqs`, `/es`): the server sends signed-in visitors to the
 * SPA even on public pages, and the SPA's routes have no language prefix. Take the language from the URL,
 * then drop the prefix so the SPA's own route renders, before anything reads the language.
 *
 * The URL is a request for that language, so it becomes the reader's choice, as if picked in the switcher.
 * Imported for its side effect at the top of main.tsx, ahead of `@/lib/i18n`, which reads the choice at load.
 */
export function applyLocalePrefix(location: Pick<Location, 'pathname' | 'search' | 'hash'>, history: Pick<History, 'replaceState' | 'state'>): void {
    const split = splitLocalePrefix(location.pathname);
    if (!split) return;
    setLocale(split.locale);
    history.replaceState(history.state, '', `${split.path}${location.search}${location.hash}`);
}

if (typeof window !== 'undefined') {
    applyLocalePrefix(window.location, window.history);
}
